function getApiURL() {
    return getEnvironmentVariable(process.env.NEXT_PUBLIC_API_BASE_URL);
}

function getAppStaging(): string {
    return getEnvironmentVariable(process.env.NEXT_PUBLIC_APP_STAGING);
}

function getCanonicalURL() {
    // Always the public URL: used to build links/redirects/canonical tags shown
    // to the actual browser, which can never be pointed at an internal address.
    return getEnvironmentVariable(process.env.NEXT_PUBLIC_CANNONICAL_URL);
}

function getCmsInternalApiUrl() {
    // Self-fetch (this server calling its own /api/cms proxy route) can't reach
    // the public NEXT_PUBLIC_CANNONICAL_URL when it's not routable from inside
    // this container (e.g. hairpin NAT back to the box's own public IP).
    // INTERNAL_API_BASE_URL overrides the base for this server-only call;
    // unset (the normal/prod case) falls back to the public URL as before.
    const isServer = typeof window === 'undefined';
    const internalBase = isServer ? process.env.INTERNAL_API_BASE_URL : undefined;
    const base = internalBase || getCanonicalURL();
    return getEnvironmentVariable(base).concat('/api/cms');
}

function getContactEmailAddress() {
    return getEnvironmentVariable(process.env.NEXT_PUBLIC_CONTACT_EMAIL_ADDRESS);
}

function getGoogleTagManager() {
    return getEnvironmentVariable(process.env.NEXT_PUBLIC_TAG_MANAGER);
}

function getGoogleReCaptchaPublicKey() {
    return getEnvironmentVariable(process.env.NEXT_PUBLIC_RECAPTCHA_PUBLIC_KEY);
}

function getGoogleReCaptchaSecretKey() {
    return getEnvironmentVariable(process.env.NEXT_PUBLIC_RECAPTCHA_SECRET_KEY);
}

function getI18nAdditionalLanguages() {
    return process.env.NEXT_PUBLIC_APP_AVAILABLE_LANGUAGES as string;
}

function getI18nDefaultLanguage() {
    return getEnvironmentVariable(process.env.NEXT_PUBLIC_APP_MAIN_LANGUAGE);
}

function getInstanceCountryCode() {
    return getEnvironmentVariable(process.env.NEXT_PUBLIC_INSTANCE_COUNTRY_CODE);
}

function getSelfFetchBaseURL() {
    // NEXT_PUBLIC_API_URL/NEXT_PUBLIC_BASE_URL point at this app's own
    // /api/directsales-site-web/* proxy routes (self-fetch), same as
    // getCmsInternalApiUrl. Server-side, the public canonical URL isn't
    // reachable from inside this container, so use INTERNAL_API_BASE_URL.
    const isServer = typeof window === 'undefined';
    const internalBase = isServer ? process.env.INTERNAL_API_BASE_URL : undefined;
    return getEnvironmentVariable(internalBase || getCanonicalURL());
}

function getPublicApiURL() {
    return getSelfFetchBaseURL().concat(getEnvironmentVariable(process.env.NEXT_PUBLIC_API_URL));
}

function getPublicBaseURL() {
    return getSelfFetchBaseURL().concat(getEnvironmentVariable(process.env.NEXT_PUBLIC_BASE_URL));
}

function getSellZone() {
    return getEnvironmentVariable(process.env.NEXT_PUBLIC_SELL_ZONE);
}

function getStrapiURL() {
    return getEnvironmentVariable(process.env.NEXT_PUBLIC_STRAPI_API_URL);
}

function getStrapiImageURL() {
    return getEnvironmentVariable(process.env.NEXT_PUBLIC_STRAPI_IMAGE_URL);
}

function getStrapiToken() {
    return getEnvironmentVariable(process.env.NEXT_PUBLIC_STRAPI_TOKEN);
}

function getEnvironmentVariable(value: string | undefined): string {
    if (!value) {
        throw new Error('Environment variable is not set. Check environment configuration file');
    }
    return value;
}

export const EnvironmentService = {
    getApiURL,
    getAppStaging,
    getCanonicalURL,
    getCmsInternalApiUrl,
    getContactEmailAddress,
    getGoogleTagManager,
    getGoogleReCaptchaPublicKey,
    getGoogleReCaptchaSecretKey,
    getI18nAdditionalLanguages,
    getI18nDefaultLanguage,
    getInstanceCountryCode,
    getPublicApiURL,
    getPublicBaseURL,
    getSellZone,
    getStrapiImageURL,
    getStrapiToken,
    getStrapiURL
};
